import React from 'react';
import Add from 'shared/components/vxl/icon/icons/Add';
import AddMoney from 'shared/components/vxl/icon/icons/AddMoney';
import AndroidFace from 'shared/components/vxl/icon/icons/AndroidFace';
import AndroidFingerprint from 'shared/components/vxl/icon/icons/AndroidFingerprint';
import ApplePay from 'shared/components/vxl/icon/icons/ApplePay';
import Appstore from 'shared/components/vxl/icon/icons/Appstore';
import APY from 'shared/components/vxl/icon/icons/APY';
import ArrowDown from 'shared/components/vxl/icon/icons/ArrowDown';
import ArrowLeft from 'shared/components/vxl/icon/icons/ArrowLeft';
import ArrowRight from 'shared/components/vxl/icon/icons/ArrowRight';
import ArrowUp from 'shared/components/vxl/icon/icons/ArrowUp';
import ATM from 'shared/components/vxl/icon/icons/ATM';
import Back from 'shared/components/vxl/icon/icons/Back';
import Backspace from 'shared/components/vxl/icon/icons/Backspace';
import Bank from 'shared/components/vxl/icon/icons/Bank';
import Barcode from 'shared/components/vxl/icon/icons/Barcode';
import Basketball from 'shared/components/vxl/icon/icons/Basketball';
import Bolt from 'shared/components/vxl/icon/icons/Bolt';
import Calendar from 'shared/components/vxl/icon/icons/Calendar';
import Camera from 'shared/components/vxl/icon/icons/Camera';
import Card from 'shared/components/vxl/icon/icons/Card';
import Cashback from 'shared/components/vxl/icon/icons/Cashback';
import ChevronDown from 'shared/components/vxl/icon/icons/ChevronDown';
import ChevronLeft from 'shared/components/vxl/icon/icons/ChevronLeft';
import ChevronRight from 'shared/components/vxl/icon/icons/ChevronRight';
import ChevronUp from 'shared/components/vxl/icon/icons/ChevronUp';
import Circle from 'shared/components/vxl/icon/icons/Circle';
import Clock from 'shared/components/vxl/icon/icons/Clock';
import ClockFilled from 'shared/components/vxl/icon/icons/ClockFilled';
import Close from 'shared/components/vxl/icon/icons/Close';
import CloseCircle from 'shared/components/vxl/icon/icons/CloseCircle';
import Coffee from 'shared/components/vxl/icon/icons/Coffee';
import Copy from 'shared/components/vxl/icon/icons/Copy';
import CreditScore from 'shared/components/vxl/icon/icons/CreditScore';
import DepositCash from 'shared/components/vxl/icon/icons/DepositCash';
import DirectDeposit from 'shared/components/vxl/icon/icons/DirectDeposit';
import Dispute from 'shared/components/vxl/icon/icons/Dispute';
import Download from 'shared/components/vxl/icon/icons/Download';
import Drawer from 'shared/components/vxl/icon/icons/Drawer';
import EarlyPayday from 'shared/components/vxl/icon/icons/EarlyPayday';
import Edit from 'shared/components/vxl/icon/icons/Edit';
import Edit2 from 'shared/components/vxl/icon/icons/Edit2';
import Ellipse from 'shared/components/vxl/icon/icons/Ellipse';
import Email from 'shared/components/vxl/icon/icons/Email';
import Entertainment from 'shared/components/vxl/icon/icons/Entertainment';
import Error from 'shared/components/vxl/icon/icons/Error';
import Exchange from 'shared/components/vxl/icon/icons/Exchange';
import Facebook from 'shared/components/vxl/icon/icons/Facebook';
import FaceID from 'shared/components/vxl/icon/icons/FaceID';
import FDIC from 'shared/components/vxl/icon/icons/FDIC';
import FlashOff from 'shared/components/vxl/icon/icons/FlashOff';
import FlashOn from 'shared/components/vxl/icon/icons/FlashOn';
import Freeze from 'shared/components/vxl/icon/icons/Freeze';
import Gas from 'shared/components/vxl/icon/icons/Gas';
import GenericContact from 'shared/components/vxl/icon/icons/GenericContact';
import Gift from 'shared/components/vxl/icon/icons/Gift';
import GooglePay from 'shared/components/vxl/icon/icons/GooglePay';
import Hide from 'shared/components/vxl/icon/icons/Hide';
import Home from 'shared/components/vxl/icon/icons/Home';
import Info from 'shared/components/vxl/icon/icons/Info';
import Instagram from 'shared/components/vxl/icon/icons/Instagram';
import LightBulb from 'shared/components/vxl/icon/icons/LightBulb';
import Linkedin from 'shared/components/vxl/icon/icons/Linkedin';
import LinkExternalAccounts from 'shared/components/vxl/icon/icons/LinkExternalAccounts';
import ListCheckMark from 'shared/components/vxl/icon/icons/ListCheckMark';
import ListWarningMark from 'shared/components/vxl/icon/icons/ListWarningMark';
import ListXMark from 'shared/components/vxl/icon/icons/ListXMark';
import Loan from 'shared/components/vxl/icon/icons/Loan';
import Location from 'shared/components/vxl/icon/icons/Location';
import Lock from 'shared/components/vxl/icon/icons/Lock';
import LockFilled from 'shared/components/vxl/icon/icons/LockFilled';
import LogIn from 'shared/components/vxl/icon/icons/LogIn';
import Manage from 'shared/components/vxl/icon/icons/Manage';
import MobileDeposit from 'shared/components/vxl/icon/icons/MobileDeposit';
import Money from 'shared/components/vxl/icon/icons/Money';
import MoneyBag from 'shared/components/vxl/icon/icons/MoneyBag';
import More from 'shared/components/vxl/icon/icons/More';
import MoveMoney from 'shared/components/vxl/icon/icons/MoveMoney';
import NoFees from 'shared/components/vxl/icon/icons/NoFees';
import Notification from 'shared/components/vxl/icon/icons/Notification';
import Perks from 'shared/components/vxl/icon/icons/Perks';
import Phone from 'shared/components/vxl/icon/icons/Phone';
import PiggyBank from 'shared/components/vxl/icon/icons/PiggyBank';
import Placeholder from 'shared/components/vxl/icon/icons/Placeholder';
import Play from 'shared/components/vxl/icon/icons/Play';
import Playstore from 'shared/components/vxl/icon/icons/Playstore';
import Profile from 'shared/components/vxl/icon/icons/Profile';
import QuestionMark from 'shared/components/vxl/icon/icons/QuestionMark';
import Restaurants from 'shared/components/vxl/icon/icons/Restaurants';
import Search from 'shared/components/vxl/icon/icons/Search';
import Secure from 'shared/components/vxl/icon/icons/Secure';
import Send from 'shared/components/vxl/icon/icons/Send';
import Settings from 'shared/components/vxl/icon/icons/Settings';
import Share from 'shared/components/vxl/icon/icons/Share';
import Shopping from 'shared/components/vxl/icon/icons/Shopping';
import Skip from 'shared/components/vxl/icon/icons/Skip';
import Sparkle from 'shared/components/vxl/icon/icons/Sparkle';
import SparkleFilled from 'shared/components/vxl/icon/icons/SparkleFilled';
import Star from 'shared/components/vxl/icon/icons/Star';
import StarFilled from 'shared/components/vxl/icon/icons/StarFilled';
import StatusError from 'shared/components/vxl/icon/icons/StatusError';
import StatusInfo from 'shared/components/vxl/icon/icons/StatusInfo';
import StatusSuccess from 'shared/components/vxl/icon/icons/StatusSuccess';
import StatusWarning from 'shared/components/vxl/icon/icons/StatusWarning';
import Store from 'shared/components/vxl/icon/icons/Store';
import Success from 'shared/components/vxl/icon/icons/Success';
import Sun from 'shared/components/vxl/icon/icons/Sun';
import Support from 'shared/components/vxl/icon/icons/Support';
import Text from 'shared/components/vxl/icon/icons/Text';
import ThumbsDown from 'shared/components/vxl/icon/icons/ThumbsDown';
import ThumbsDownFilled from 'shared/components/vxl/icon/icons/ThumbsDownFilled';
import ThumbsUp from 'shared/components/vxl/icon/icons/ThumbsUp';
import ThumbsUpFilled from 'shared/components/vxl/icon/icons/ThumbsUpFilled';
import TicketFilled from 'shared/components/vxl/icon/icons/TicketFilled';
import Tips from 'shared/components/vxl/icon/icons/Tips';
import Tools from 'shared/components/vxl/icon/icons/Tools';
import TouchID from 'shared/components/vxl/icon/icons/TouchID';
import TransactionHistory from 'shared/components/vxl/icon/icons/TransactionHistory';
import Transfer from 'shared/components/vxl/icon/icons/Transfer';
import Travel from 'shared/components/vxl/icon/icons/Travel';
import Twitter from 'shared/components/vxl/icon/icons/Twitter';
import Umbrella from 'shared/components/vxl/icon/icons/Umbrella';
import VaroToVaro from 'shared/components/vxl/icon/icons/VaroToVaro';
import Vault from 'shared/components/vxl/icon/icons/Vault';
import View from 'shared/components/vxl/icon/icons/View';
import VolumeOff from 'shared/components/vxl/icon/icons/VolumeOff';
import VolumeOn from 'shared/components/vxl/icon/icons/VolumeOn';
import Warning from 'shared/components/vxl/icon/icons/Warning';
import Youtube from 'shared/components/vxl/icon/icons/Youtube';
import theme from 'shared/styles/theme';

export type IconKeyType = keyof typeof Icons;

export interface IconProps {
  /** Can be used to change the color of the icon. */
  iconColor?: string;

  /** The icon key is used to render a specific icon. The icon key is a string from a predefined list of values. */
  iconKey: IconKeyType | undefined;

  /** The size of the icon. VXL has three sizes, ```XS``` (12), ```SM``` (16), ```MD``` (24) which are acceptable values. The icon component also allows custom values as a ```number``` to be passed as the size, although this should be used sparingly. */
  iconSize?: 'XS' | 'SM' | 'MD' | number;

  /** The accessibility label for the icon. */
  iconAccessibilityLabel?: string;
}

export const IconSizes: Record<string, number> = {
  XS: 12,
  SM: 16,
  MD: 24,
};

export const Icons: Record<string, (props: IconProps) => React.JSX.Element> = {
  ADD: Add,
  ADD_MONEY: AddMoney,
  ANDROID_FACE: AndroidFace,
  ANDROID_FINGERPRINT: AndroidFingerprint,
  APPLE_PAY: ApplePay,
  APPSTORE: Appstore,
  GOOGLE_PAY: GooglePay,
  APY: APY,
  ARROW_DOWN: ArrowDown,
  ARROW_LEFT: ArrowLeft,
  ARROW_RIGHT: ArrowRight,
  ARROW_UP: ArrowUp,
  ATM: ATM,
  BACK: Back,
  BACKSPACE: Backspace,
  BANK: Bank,
  BASKETBALL: Basketball,
  BOLT: Bolt,
  CALENDAR: Calendar,
  CAMERA: Camera,
  CARD: Card,
  CASHBACK: Cashback,
  CHEVRON_DOWN: ChevronDown,
  CHEVRON_LEFT: ChevronLeft,
  CHEVRON_RIGHT: ChevronRight,
  CHEVRON_UP: ChevronUp,
  CIRCLE: Circle,
  CLOCK: Clock,
  CLOCK_FILLED: ClockFilled,
  CLOSE: Close,
  CLOSE_CIRCLE: CloseCircle,
  COFFEE: Coffee,
  COPY: Copy,
  CREDIT_SCORE: CreditScore,
  DEPOSIT_CASH: DepositCash,
  DIRECT_DEPOSIT: DirectDeposit,
  DISPUTE: Dispute,
  DOWNLOAD: Download,
  DRAWER: Drawer,
  EARLY_PAYDAY: EarlyPayday,
  EDIT: Edit,
  EDIT_2: Edit2,
  ELLIPSE: Ellipse,
  EMAIL: Email,
  ENTERTAINMENT: Entertainment,
  ERROR: Error,
  EXCHANGE: Exchange,
  FACEBOOK: Facebook,
  FACE_ID: FaceID,
  FDIC: FDIC,
  FLASH_OFF: FlashOff,
  FLASH_ON: FlashOn,
  FREEZE: Freeze,
  GAS: Gas,
  GENERIC_CONTACT: GenericContact,
  GIFT: Gift,
  HIDE: Hide,
  HOME: Home,
  INFO: Info,
  INSTAGRAM: Instagram,
  LIGHT_BULB: LightBulb,
  LINK_EXTERNAL_ACCOUNTS: LinkExternalAccounts,
  LINKEDIN: Linkedin,
  LIST_CHECK_MARK: ListCheckMark,
  LIST_WARNING_MARK: ListWarningMark,
  LIST_X_MARK: ListXMark,
  LOAN: Loan,
  LOCATION: Location,
  LOCK_FILLED: LockFilled,
  LOCK: Lock,
  LOG_IN: LogIn,
  MANAGE: Manage,
  MOBILE_DEPOSIT: MobileDeposit,
  MONEY_BAG: MoneyBag,
  MONEY: Money,
  MORE: More,
  MOVE_MONEY: MoveMoney,
  NO_FEES: NoFees,
  NOTIFICATION: Notification,
  PERKS: Perks,
  PHONE: Phone,
  PIGGY_BANK: PiggyBank,
  PLACEHOLDER: Placeholder,
  PLAY: Play,
  PLAYSTORE: Playstore,
  PROFILE: Profile,
  QUESTION_MARK: QuestionMark,
  RESTAURANTS: Restaurants,
  SEARCH: Search,
  SECURE: Secure,
  SEND: Send,
  SETTINGS: Settings,
  SHARE: Share,
  SHOPPING: Shopping,
  SKIP: Skip,
  SPARKLE: Sparkle,
  SPARKLE_FILLED: SparkleFilled,
  STAR_FILLED: StarFilled,
  STAR: Star,
  STATUS_ERROR: StatusError,
  STATUS_INFO: StatusInfo,
  STATUS_SUCCESS: StatusSuccess,
  STATUS_WARNING: StatusWarning,
  STORE: Store,
  SUCCESS: Success,
  SUN: Sun,
  SUPPORT: Support,
  TEXT: Text,
  THUMBS_DOWN_FILLED: ThumbsDownFilled,
  THUMBS_DOWN: ThumbsDown,
  THUMBS_UP_FILLED: ThumbsUpFilled,
  THUMBS_UP: ThumbsUp,
  TICKET_FILLED: TicketFilled,
  TIPS: Tips,
  TOOLS: Tools,
  TOUCH_ID: TouchID,
  TRANSACTION_HISTORY: TransactionHistory,
  TRANSFER: Transfer,
  TRAVEL: Travel,
  TWITTER: Twitter,
  UMBRELLA: Umbrella,
  VARO_TO_VARO: VaroToVaro,
  VAULT: Vault,
  VIEW: View,
  VOLUME_OFF: VolumeOff,
  VOLUME_ON: VolumeOn,
  WARNING: Warning,
  YOUTUBE: Youtube,
  BARCODE: Barcode,
};

export const defaultIconColor = theme.color.text.primary;

const Icon = ({
  iconKey = 'PLACEHOLDER',
  iconColor = defaultIconColor,
  iconAccessibilityLabel,
  iconSize = 'MD',
}: IconProps) => {
  const RenderIcon = Icons[iconKey] ?? Icons.PLACEHOLDER;
  const computedSize = IconSizes[iconSize] ?? iconSize;

  const propsForRenderIcon = {
    iconKey,
    iconColor,
    iconSize: computedSize,
    iconAccessibilityLabel,
  };

  return <RenderIcon {...propsForRenderIcon} />;
};

export default Icon;
